import { type QueryHookOptions, useQuery } from "@apollo/client";
import { EventCancelPreviewQuery } from "../graphql/queries";
import type {
  EventCancelPreviewQueryType,
  EventCancelPreviewQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useEventCancelPreviewQuery = (
  options?: QueryHookOptions<
    EventCancelPreviewQueryType,
    EventCancelPreviewQueryVariablesType
  >
) =>
  useQuery<EventCancelPreviewQueryType, EventCancelPreviewQueryVariablesType>(
    EventCancelPreviewQuery,
    options
  );
